import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DaterangePickerComponent, DaterangepickerConfig} from 'ng2-daterangepicker';
import {ValidatorUtils} from "../../shared/utils/src/validator.utils";

@Component({
    selector: 'app-datetime-rangepicker',
    templateUrl: 'datetime-rangepicker.component.html'
})
export class DatetimeRangepickerComponent implements OnInit, OnDestroy {

    // @Input() selectOption: any;
    // @Input() selectedValue: string;

    // 부모로부터 timezoneOffset 적용된 값을 받음.
    @Input() fromDate: string;
    @Input() fromTime: string;
    @Input() toDate: string;
    @Input() toTime: string;

    @Output() setTimes: EventEmitter<any> = new EventEmitter<any>();

    //ng2-daterangepicker component
    @ViewChild(DaterangePickerComponent)
    private picker: DaterangePickerComponent;

    preFromDate = '';
    preFromTime = '';
    preToDate = '';
    preToTime = '';

    // ToDo : Calendar 와 Timepicker 설정을 모두 Parent에서 할 수 있도록 변경
    calOptions: any;
    timeOptions: any;
    private tmznOfs = '+09:00';

    isInvalidTime = false ;  // 시작시간과 종료시간보다 큰 경우
    isInvalidTime2 = false ; // 시작시간이 현재시간보다 과거이거나 종료시간이 현재시간보다 과거인 경우

    calendarParams: any = {
        fromDate: '',
        fromTime: '',
        toDate: '',
        toTime: ''
    };

    constructor(private daterangepickerOptions: DaterangepickerConfig) {
        this.tmznOfs = global['loginUser'].tmznAplyTypeCd === 'LOGIN_TIMEZONE' ? global['loginUser'].loginTmznOfs : global['loginUser'].prflTmznOfs;
        this.daterangepickerOptions.skipCSS = true;
    }

    ngOnInit() {
        const _x = this;

        // calendar settings
        this.calOptions = {
            singleDatePicker: true,
            locale: { format: 'YYYY-MM-DD' },
            alwaysShowCalendars: false,
            autoUpdateInput: true,
            minDate: moment().utcOffset(this.tmznOfs)/*,
            maxDate: moment().utcOffset(this.tmznOfs).add(this.selectedValue, 'd')*/
        };

        this.timeOptions = {
            timeFormat: 'H:i',
            // disableTextInput: false, // true 이면 키보드 입력 불가
            // selectOnBlur: true,
            scrollDefault: 'now',
            show2400: true,
            minTime: '00:00',
            maxTime: '23:59',
            step: 30
        };

        $('#from_time2').timepicker(this.timeOptions);
        $('#to_time2').timepicker(this.timeOptions);


        $('#from_time2').on('changeTime', function(e) {
            // _x.toDate = moment($('#from_date2').val() + ' ' + $('#from_time2').val()).add(_x.selectedValue, 'm').format('YYYY-MM-DD');
            // _x.toTime = moment($('#from_date2').val() + ' ' + $('#from_time2').val()).add(_x.selectedValue, 'm').format('HH:mm');
            _x.fromDate = moment($('#from_date2').val() + ' ' + $('#from_time2').val()).format('YYYY-MM-DD');
            _x.fromTime = moment($('#from_date2').val() + ' ' + $('#from_time2').val()).format('HH:mm');
        });

        $('#to_time2').on('changeTime', function(e) {
            _x.toDate = moment($('#to_date2').val() + ' ' + $('#to_time2').val()).format('YYYY-MM-DD');
            _x.toTime = moment($('#to_date2').val() + ' ' + $('#to_time2').val()).format('HH:mm');
            // _x.fromDate = moment($('#to_date2').val() + ' ' + $('#to_time2').val()).subtract(_x.selectedValue, 'm').format('YYYY-MM-DD');
            // _x.fromTime = moment($('#to_date2').val() + ' ' + $('#to_time2').val()).subtract(_x.selectedValue, 'm').format('HH:mm');
        });
    }

    ngOnDestroy() {
        $('#from_time2').timepicker('remove');
        $('#to_time2').timepicker('remove');
    }

    public selectedDate(value: any) {
    }

    public calendarCanceled(e: any) {
        // e.event
        // e.picker
    }

    public calendarApplied(e: any) {
        if (e.event.currentTarget.id === 'from_date2') {
            this.fromDate = e.picker.startDate.format('YYYY-MM-DD');
        } else {
            this.toDate = e.picker.startDate.format('YYYY-MM-DD');
        }
    }

    public sendDateParam() {
        this.setTimes.emit({
            fromDate: $('#from_date2').val(),
            fromTime: $('#from_time2').val(),
            toDate: $('#to_date2').val(),
            toTime: $('#to_time2').val()
        });
    }

    public onFromTimeChange(event) {
        // console.log('[onFromTimeChange] value:' + event);
    }

    public onToTimeChange(event) {
        // console.log('[onToTimeChange] value:' + event);
    }

    /* 현재 사용 안함, 시간 변경 : for Popup */
    /*public setTimeInterval(event) {
        this.setTimes.emit({
            fromDate: $('#from_date2').val(),
            fromTime: $('#from_time2').val(),
            toDate: $('#to_date2').val(),
            toTime: $('#to_time2').val()
        });
        //this.expandYN = !this.expandYN;


        this.timeOptions = {
            'timeFormat': 'H:i',
            'disableTextInput': true,
            'selectOnBlur': true,
            'show2400': true,
            //'minTime': this.fromTime,
            //'maxTime': '23:59',
            'step': event
        };

        this.selectedValue = event;
        $('#from_time2').timepicker(this.timeOptions);
        $('#to_time2').timepicker(this.timeOptions);

        // console.log('[setTimeInterval] options: ', this.timeOptions);

        // console.log(event);
        const fromDt = $('#from_date2').val();
        const fromTm = $('#from_time2').val();
        this.toDate = moment(fromDt + ' ' + fromTm).add(event, 'm').format('YYYY-MM-DD');
        this.toTime = moment(fromDt + ' ' + fromTm).add(event, 'm').format('HH:mm');
    }*/

    /* 현재 사용 안함 */
    /*setDuration(value: string) {
        const _x = this;

        this.selectedValue = value;

        _x.fromDate = moment().utcOffset(this.tmznOfs).format('YYYY-MM-DD');
        _x.fromTime = moment().utcOffset(this.tmznOfs).format('HH:mm');
        _x.toDate = moment().utcOffset(this.tmznOfs).add(_x.selectedValue, 'm').format('YYYY-MM-DD');
        _x.toTime = moment().utcOffset(this.tmznOfs).add(_x.selectedValue, 'm').format('HH:mm');
    }*/

    /* datepicker 유효성 체크 */
    dateValidCheck(): number {
        // 1. 초기화
        //this.validCheckInit();
        this.isInvalidTime = false;
        this.isInvalidTime2 = false;

        /*
        if (this.invalidCnt === 0) {
            // 4. 유효성 체크
            this.dateRangeValidCheck();
        }
        console.log('invalidCnt... : ' + this.invalidCnt);
        return this.invalidCnt;
        */

        return this.dateRangeValidCheck();
    }

    /* 기간 유효성 체크 */
    dateRangeValidCheck() {
        const startDate = moment(this.fromDate + ' ' + this.fromTime).format('YYYY-MM-DD HH:mm');
        const endDate = moment(this.toDate + ' ' + this.toTime).format('YYYY-MM-DD HH:mm');
        const currDate = moment().utcOffset(this.tmznOfs).format('YYYY-MM-DD HH:mm');
        console.log('startDate: ' + startDate + ', endDate: ' + endDate + ', currDate: ' + currDate);
        // 종료시간이 시작시간보다 빠를 경우
        if (moment(endDate, 'YYYY-MM-DD HH:mm').diff(startDate, 'YYYY-MM-DD HH:mm') < 0) {
            this.isInvalidTime = true;
            return 1;
        }
        // 현재 시간과 시작 시간이 120초 이상일 경우
        if (moment(currDate, 'YYYY-MM-DD HH:mm').utcOffset(this.tmznOfs).diff(startDate, 'YYYY-MM-DD HH:mm') > 120000) {
            this.isInvalidTime2 = true;
            return 1;
        }
        // 현재 시간과 종료 시간이 120초 이상일 경우
        if (moment(currDate, 'YYYY-MM-DD HH:mm').utcOffset(this.tmznOfs).diff(endDate, 'YYYY-MM-DD HH:mm') > 120000) {
            this.isInvalidTime2 = true;
            return 1;
        }

        return 0;
    }

    onDateChange(event: any, type) {
        if (event.type === 'keydown') {
            return ValidatorUtils.onlyDate(event);
        } else {
            if (!ValidatorUtils.checkDate(event.target.value)) {
                if (type === 'from') {
                    this.fromDate = this.preFromDate;
                } else {
                    this.toDate = this.preToDate;
                }
            }
        }
    }

    onTimeChange(event: any, type) {
        if (event.type === 'keydown') {
            return ValidatorUtils.onlyTime(event);
        } else {
            if (ValidatorUtils.checkTime(event.target.value)) {
                if (type === 'from') {
                    this.preFromTime = this.fromTime = event.target.value;
                } else {
                    this.preToTime = this.toTime = event.target.value;
                }
            } else {
                if (type === 'from') {
                    this.fromTime = this.preFromTime;
                } else {
                    this.toTime = this.preToTime;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/datetime-rangepicker/datetime-rangepicker.component.ts